// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AiFormAepFragmentDoc } from '../../../../../components/formFields/ai/utils/aiProposalForm.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TakeoffProposalsQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type TakeoffProposalsQuery = { __typename?: 'Query', planPackage: { __typename?: 'PlanPackage', id: string, aiProposal?: { __typename?: 'PlanPackageAiProposal', id: string, entityProposals: Array<{ __typename?: 'AiEntityProposal', id: string, rationalization?: string | null | undefined, type: { __typename?: 'AiEntityProposalTypeDetail', code: Types.AiEntityProposalType }, entity:
          | { __typename: 'MaterialListing', id: string }
          | { __typename: 'MaterialVariant', id: string }
          | { __typename: 'ReadyPlanLocation', id: string }
          | { __typename: 'ReadyPlanOption', id: string }
          | { __typename: 'ReadyPlanProgramData', id: string }
          | { __typename: 'TakeoffLineItem', id: string }
        , fieldProposals: Array<{ __typename?: 'AiFieldProposal', id: string, fieldName: string, fieldValue?: string | null | undefined, parentType: Types.AiEntityProposalType, pageNumbers?: Array<number> | null | undefined, status: { __typename?: 'AiFieldProposalStatusDetail', code: Types.AiFieldProposalStatus } }> }> } | null | undefined } };


export const TakeoffProposalsDocument = gql`
    query TakeoffProposals($id: ID!, $versionId: ID!) {
  planPackage(id: $id, versionId: $versionId) {
    id
    aiProposal {
      id
      entityProposals(entityType: [TAKEOFF_LINE_ITEM]) {
        ...AiFormAep
      }
    }
  }
}
    ${AiFormAepFragmentDoc}`;

/**
 * __useTakeoffProposalsQuery__
 *
 * To run a query within a React component, call `useTakeoffProposalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTakeoffProposalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTakeoffProposalsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useTakeoffProposalsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TakeoffProposalsQuery, TakeoffProposalsQueryVariables> & ({ variables: TakeoffProposalsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>(TakeoffProposalsDocument, options);
      }
export function useTakeoffProposalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>(TakeoffProposalsDocument, options);
        }
// @ts-ignore
export function useTakeoffProposalsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>;
export function useTakeoffProposalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TakeoffProposalsQuery | undefined, TakeoffProposalsQueryVariables>;
export function useTakeoffProposalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>(TakeoffProposalsDocument, options);
        }
export type TakeoffProposalsQueryHookResult = ReturnType<typeof useTakeoffProposalsQuery>;
export type TakeoffProposalsLazyQueryHookResult = ReturnType<typeof useTakeoffProposalsLazyQuery>;
export type TakeoffProposalsSuspenseQueryHookResult = ReturnType<typeof useTakeoffProposalsSuspenseQuery>;
export type TakeoffProposalsQueryResult = ApolloReactCommon.QueryResult<TakeoffProposalsQuery, TakeoffProposalsQueryVariables>;